<template>

  <div class="box" @click="startPrinting('1')">
    <div class="box_title">
      <span style="color: rgba(105, 109, 115, 1)"
        >{{ $t("更新时间") }}:{{ requestTime }}</span
      >
      <img
        src="./images/shua.png"
        alt=""
        width="16px"
        @click="shauxinAll"
        style="cursor: pointer"
      /><span @click="refresh" class="piliang">{{
        this.$t("刷新频率设置")
      }}</span>
      <span class="piliang2" @click="sampling">{{ $t("采样频率设置") }}</span>
    </div>
    <Tabs
      v-model="currDidTab"
      class="tab_inner"
      name="bb"
      type="line"
      @on-click="change_tab2"
    >
      <!-- @click="sampling" -->
      <TabPane
        v-for="(value, index) in details_data"
        :key="index"
        :label="$t('Changelang.' + value)"
        :name="index.toString()"
      >
        <div>
          <div class="info_box">
            <div>
                  <div
                v-if="
                  currDidTab == index.toString() && value === '设备信息'
                "
              >
                <deviceInfo></deviceInfo>
              </div>
               <div
                v-else-if="
                  currDidTab == index.toString() && value === '实时数据'
                "
              >
                <realtimeData></realtimeData>
              </div>
               <div
                v-else-if="
                  currDidTab == index.toString() && value === 'PV数据'
                "
              >
                <pvData></pvData>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '固件升级'
                "
              >
                <div class="box2">
                  <div  v-for="(value, key, index) in firmware_list"
                    class="div_ota"
                  >
                    <div v-if="value.is_update == 0">
                      <div
                        class="uploadBtn"
                        v-if="value.is_update === 0"
                        style="display: inline-block"
                      >
                        <strong
                          >{{ $t("通道") }}{{ value.chan_id }}：{{
                            $t("当前已是最新版本")
                          }}</strong
                        >
                        <br />
                        <Button
                          type="primary"
                          class="jiance"
                          @click="check_new(value.chan_id)"
                          >{{ $t("检测新版本") }}</Button
                        >
                      </div>
                    </div>
                    <div class="div_ota" v-else>
                      <div class="uploadBtn" style="display: inline-block">
                        <strong
                          >{{ $t("通道") }}{{ value.chan_id }}：{{
                            $t("检测到新固件")
                          }}{{ value.firmware_ver.firmware_ver }}</strong
                        >
                        <br />
                        <Button
                          type="primary"
                          @click="uploadFirmware(value.chan_id)"
                          class="jiance"
                          v-if="value.is_shengji"
                        >
                          {{ $t("立即升级") }}</Button
                        >
                        <!-- <Button   type="primary"
                                              @click="progress(value.chan_id)" class="jiance" >进度测试</Button>  -->
                        <div class="progress" v-if="value.is_jindu">
                          <span class="progress_text"
                            >{{ $t("升级进度") }}:{{
                              $t(value.progress_text)
                            }}</span
                          >
                          <Progress
                            :percent="value.progress_percent"
                            :stroke-width="20"
                            text-inside
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '参数设置'
                "
              >
                <Control></Control>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '历史记录'
                "
              >
                <DistributionLog :hasDid="1"></DistributionLog>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '告警数据'
                "
              >
                <AlermDes :hasDid="1"></AlermDes>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '历史轨迹'
                "
              >
                <Historyrouter></Historyrouter>
              </div>
              <div
                v-else-if="
                  currDidTab == index.toString() && value === '密码管理'
                "
              >
                <Input
                  :type="passwordType"
                  :icon="passwordTypeIcon"
                  @on-click="swicthPassword"
                  style="width: 200px; margin-right: 15px"
                  :placeholder="$t('devicelist.inputnewpass')"
                  v-model="password"
                />
                <!-- @click="savepassword" -->
                <Button type="primary" @click="savepassword">{{
                  $t("保存")
                }}</Button>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
    </Tabs>
    <Modal
      :title="$t('刷新频率更改')"
      v-model="booleanModel"
      :closable="false"
      @on-ok="modal7Ok"
      @on-cancel="modal7cancel"
      :mask-closable="false"
    >
      <p>{{ $t("长时间未操作") }}</p>
    </Modal>
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import samplingCustom from "./components/samplingCustom";
import deviceInfo from "./components/deviceInfo";
import pvData from "./components/pvData";
import realtimeData from "./components/realtimeData";
import refreshCustom from "./components/refreshCustom";
import DistributionLog from "../devicedistribution/distributionLog1";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import {
  config_caiyang_pinglv,
  web_issue_order,
  upup_firmware,
  progress_firmware,
  did_config_pass,
  get_firmware_info
} from "@/api/jingxiaoshang"
import * as echarts from "echarts";
export default {
  name: 'MechanismManage',
  mixins: [packageTableMixins],
  data () {
    return {
      is_dingji: localStorage.getItem('is_dingji'),
      progress_text: '',
      password: null,
      passwordTypeIcon: 'ios-eye',
      passwordType: 'password',
      firmware_list: [],
      booleanModel: false,
      booleanValue: null,
      interval: null,
      shuaxin: null,
      timeoutId: null,
      requestTime: null,
      chans: null,
      chansAll: null,
      did: null,
      currDidTab: '0',
      details_data: [
        '设备信息',
        '实时数据',
        'PV数据',
        '固件升级',
        '参数设置',
        '历史记录',
        '告警数据',
        '历史轨迹',
        '密码管理'
      ]
    }
  },
  components: {
    ChartPie,
    ChartItemBar,
    ChartLineStackMul2,
    DistributionLog,
    AlermDes,
    Control,
    Historyrouter,
    deviceInfo,
    realtimeData,
    pvData
  },
  methods: {

    startPrinting (val) {
      this.restartTimer();
      this.booleanValue = val || this.booleanValue;
      if (this.booleanValue == 0) {
        this.booleanModel = true;
      }
    },
    modal7Ok () {
      localStorage.setItem("shuaxin", 60 * 60);
      this.$Message.success(this.$t("设置成功"));
      this.booleanModel = false;
      this.restartTimer();
    },
    modal7cancel () {
      this.booleanModel = false;
      this.restartTimer();
    },
    restartTimer () {
      clearInterval(this.interval);
      this.initializeTimer();
    },
    initializeTimer () {
      const refreshRate = 300 * 1000;
      let valTime = localStorage.getItem("shuaxin");
      if (valTime == 3600) {
        return;
      }
      this.interval = setInterval(() => {
        this.startPrinting("0"); // 触发对话框逻辑
      }, refreshRate);
    },
    change_tab2 (tab) {
      this.currDidTab = tab;
      if (this.$route.query.tabs) {
        this.$router.push({
          path: this.$route.path, // 保留当前路径
          query: {
            ...this.$route.query, // 保留其他查询参数
            tabs: tab, // 更新 tabs 参数
          },
        });
      }

      this.check_new();
    },
    refresh () {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  // "刷新频率"
                  vm.$t("刷新频率")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(refreshCustom, {
              ref: "refreshCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                shuaxin: localStorage.getItem("shuaxin") || 60,
                parent_code: "0",
                parent_name: "无",
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.refreshCustom;
          obj.checkForm().then((res) => {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success("设置成功");
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin);
              //     vm.init()
            }
          });
          // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        },
      };
      this.$Modal.confirm(config);
    },
    sampling () {
      //   alert(sampling)
      //  return;
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t("采样频率设置")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(samplingCustom, {
              ref: "samplingCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                parent_code: "0",
                parent_name: "无",
                did: vm.did,
                caiyang_pinglv: this.caiyang_pinglv,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.samplingCustom;
          obj.checkForm().then((res) => {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv({ ...obj.formModel }).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();

                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    web_shuaxin () {
      this.did = this.$route.query.did
      if (this.$route.query.tabs) {
        this.currDidTab = this.$route.query.tabs;
      }
    },
    shauxinAll () {
      web_issue_order({
        did: this.did,
        tab_check: '4g',
        device_type: 2
      }).then((res) => {})
      setTimeout(() => {
        this.web_shuaxin()
      }, 6000)
    },
    startTimer () {
      this.shuaxin = localStorage.getItem("shuaxin") || 60;
      let shuaxintime = this.shuaxin * 1000
      this.clearTimer()
      this.timeoutId = setInterval(() => {
        this.web_shuaxin()
      }, shuaxintime)
    },

    clearTimer () {
      if (this.timeoutId) {
        clearInterval(this.timeoutId);
        this.timeoutId = null;
      }
    },
    savepassword () {
      did_config_pass({ pass: this.password, did: this.did }).then((res) => {
        let msg = res.errorMsg;
        if (res.result === 0) {
          this.$Message.success(msg);
        } else {
          this.$Message.error(msg);
        }
      });
    },
    swicthPassword () {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    uploadFirmware (dp_chan) {
      let did = this.did;
      this.result_firmware = [];
      let vm = this;
      let config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + dp_chan + "的固件吗？",
        onOk: function () {
          let _this = this;
          upup_firmware({ did: did, dp_chan: dp_chan }).then((res) => {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              _this.buttonLoading = false;
              // this.getFirmwareInfo()
              //拉取进度
              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0;
              // vm.progress_dingshi = setInterval(vm.progress, 5000);
              vm.progress_dingshi = setInterval(function () {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    //检测新的固件版本
    check_new (chan_id) {
      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({ did: this.did }).then((res) => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (this.is_update === 0) {
              //  this.$Message.info("已经是最新版本")
            } else {
              //  this.$Message.success("检测出可升级的固件")
            }
            //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)
            console.log("res.body.firmware", res.body.firmware);
            this.firmware_list = res.body.firmware;
            if (chan_id == 0 || chan_id > 0) {
              this.$Message.success(this.$t("检测成功"));
            }
          } else {
            this.is_update = 0;
            //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    progress (dp_chan) {
      let did = this.did;
      progress_firmware({ did: did, dp_chan: dp_chan }).then((res) => {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(() => {
              this.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          }
          // //拉取进度
          //this.is_jindu = 1;
          this.firmware_list[dp_chan].is_jindu = 1;
          if (res.body.jindu == 100) {
            clearInterval(this.progress_dingshi);
          }

          this.firmware_list[dp_chan].progress_percent = res.body.jindu;
          this.firmware_list[dp_chan].progress_text = res.body.ext_code;

          console.log(this.result_firmware);
          if (this.result_firmware.length >= 6) {
            let last = this.result_firmware.length - 1;
            if (
              this.result_firmware[last] == this.result_firmware[last - 1] &&
              this.result_firmware[last] == this.result_firmware[last - 2] &&
              this.result_firmware[last] == this.result_firmware[last - 3] &&
              this.result_firmware[last] == this.result_firmware[last - 4] &&
              this.result_firmware[last] == this.result_firmware[last - 5] &&
              this.result_firmware[last] == this.result_firmware[last - 6]
            ) {
              clearInterval(this.progress_dingshi);
              //this.$Message.error("固件升级超时，升级失败")
              this.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0,
              });
              this.check_new();
            }
          }
          this.result_firmware.push(res.body.jindu);
        } else {
          this.$Message.error(res.errorMsg);
          //this.is_jindu = 0;
          this.firmware_list[dp_chan].is_jindu = 0;
          //this.is_shengji = 1
          this.firmware_list[dp_chan].is_shengji = 1;
          //this.progress_percent = 0;
          this.firmware_list[dp_chan].progress_percent = 0;
          //this.progress_text = "";
          this.firmware_list[dp_chan].progress_text = "";
          clearInterval(this.progress_dingshi);
        }
        //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }
      });
    }
  },
  mounted () {
    this.web_shuaxin()
    this.startTimer()
    this.initializeTimer()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  destroyed () {}
}
</script>
<style scoped>
.box {
  position: relative;
  overflow: auto;
  min-width: 1700px;
}
.content {
  display: flex;
}
.contentLeft {
  width: 520px;
  margin-right: 12px;
  background: white;
  padding: 20px;
}
.contentLeft_top_title {
  display: flex;
}
.contentLeft_top_title div {
  width: 50%;
  color: rgba(105, 109, 115, 1);
  font-size: 14px;
  font-weight: 400;
}
.contentLeft_top_value {
  display: flex;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
}
.contentLeft_top_value div:nth-child(1) {
  width: 53%;
  flex-wrap: nowrap;
}
.contentLeft_top_value div span {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.contentLeft_top_title div:nth-child(2) {
  margin-left: 30px;
}
.contentLeft_top_title {
  margin-top: 10px;
}
.echarts_content {
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}
.echarts_content_left {
  line-height: 50%;
  font-size: 14px;
  width: 150px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 省略号 */
}
.item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.echarts_content_left div img {
  width: 16px;
}
.echarts_content_left div:nth-child(1) {
  margin-right: 5px;
}
.echarts_content_center {
  margin-left: -140px;
}
.dainchi {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.dainchi div {
  margin-right: 30px;
}
.dainchi div p {
  text-align: center;
}
.dainchi div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 600;
}
.dianchibj {
  /* background: rgba(242, 243, 246, 1); */
  /* border-radius: 6px;
  padding: 2px; */
  /* margin: auto; */
}
.fenkai {
  height: 30px;
  margin-top: 5px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.dianya {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  width: 480px;
  margin-right: auto;
  border: 1px solid rgba(225, 230, 234, 1);
  border-radius: 6px;
  padding: 10px 0;
}
.dianya div p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dianya div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 700;
  font-size: 16px;
}
.information {
  display: flex;
  margin-top: 20px;
}
.information_left {
  width: 180px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.information_left div {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.information_left div p:nth-child(2) {
  margin-left: 10px;
}
.information_left div p:nth-child(1) {
  width: 100px;
}
.progress_text {
  font-weight: bold;
}
.information_right {
  margin-left: 20px;
  font-size: 14px;
}

.information_right div p:nth-child(1) {
  width: 110px;
}

/* .container {
  width: 100%;
}
#container {
  width: 100%;
  margin-top: 5px;
}
.p {
  word-break: break-all;
  margin-left: 15px;
}
.pack {
  margin-top: -10px;
} */
/* .information_right div p:nth-child(2) {
  width: 80px;
 flex-wrap: wrap;
} */
.information_right div {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
/* .information_right div:nth-child(5) {
  margin-top: 8px;
}
.information_right div:nth-child(6) {
  margin-top: 6px;
}
.information_right div:nth-child(7) {
  margin-top: 6px;
} */
.mapcontent {
  position: relative;
}
.lookmap img {
  width: 88px;
  height: 26px;
  position: absolute;
  right: 5px;
  top: 5px;
}
.contentRight {
  width: calc(100% - 520px);
  min-width: 1000px;
  background: white;
}
.echarsView2 {
  width: 100%;
}
.box2 {
  padding: 0 20px;
}
.contentRight_footer_right_btn {
  width: 100%;
  padding-right: 150px;
}
.contentRight_title {
  position: relative;
  padding-top: 12px;
}
.contentRight_title_from {
  position: relative;
}
.contentRight_title_export {
  display: flex;
  align-items: center;
  justify-content: end;
  position: absolute;
  right: 5px;
  top: 0px;
}
.contentRight_title_export p {
  color: rgba(45, 140, 240, 1);
  font-size: 16px;
}
.contentRight_title_export {
  display: flex;
  flex-direction: row;
}
.form-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 10px; /* 元素间距 */
}
.export-item {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  margin-right: 10px; /* 每项之间的间距 */
  cursor: pointer;
}

.export-item img {
  margin-right: 4px; /* 图片与文字之间的间距 */
  width: 16px;
}
.contentRight_footer_content {
  display: flex;
}
.contentRight_footer {
  background: rgba(242, 243, 246, 1);
  padding-top: 12px;
  padding-bottom: 12px;
}
.contentRight_footer_left {
  width: 150px;
}
.contentRight_footer_left div {
  margin-top: 20px;
  margin-left: 16px;
  background: white;
}
.contentRight_footer_left div p:nth-child(1) {
  font-size: 14px;
  color: rgba(105, 109, 115, 1);
}
.contentRight_footer_left div p:nth-child(2) {
  font-size: 16px;
  font-weight: 700;
  color: rgba(53, 55, 57, 1);
}

.contentRight_footer_title {
  padding: 12px;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid rgba(225, 230, 234, 1);
}
.dianchi {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background-size: cover; /* 使背景图像覆盖整个 div */
  background-position: center; /* 居中显示背景图像 */
}
.dianchivalue {
  width: 90px;
  text-align: center;
}
.contentRight_footer_right {
  margin-left: 5px;
  width: 80%;
}
.contentRight_footer_right_top {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  height: 200px;
  overflow-y: auto;
}

.contentRight_footer_right_top div {
  flex: 0 0 90px; /* 每个元素固定宽度为 90px */
  margin-right: calc((100% - 90px * 8) / 7); /* 计算元素间距，最多 8 个元素 */
  margin-top: 5px;
}

.contentRight_footer_right_top div:nth-child(8n) {
  margin-right: 0; /* 每行最后一个元素不需要右边距 */
}
.youshang {
  display: flex;
  align-items: center;
  margin-top: -22px;
}
.chax {
  margin-right: 10px;
}
.junx {
  margin-left: 8px;
}
.box_title {
  position: absolute;
  right: 5px;
  top: 10px;
  display: flex;
  align-items: center;
  z-index: 1;
}
.box_title span {
  color: rgba(45, 140, 240, 1);
}
.box_title img {
  margin: 0 8px;
}

.piliang,
.piliang2 {
  margin-right: 10px;
  cursor: pointer;
}
</style>
